import PropTypes from 'prop-types';
import React from 'react';
import css from './ShopsHeader.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ShopsHeader = function ShopsHeader(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  return /*#__PURE__*/_jsxs("header", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("h1", {
      className: css.title,
      children: title
    }), subtitle && /*#__PURE__*/_jsx("h2", {
      className: css.subtitle,
      children: subtitle
    })]
  });
};

ShopsHeader.defaultProps = {
  subtitle: ''
};
ShopsHeader.propTypes = {
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default ShopsHeader;